import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { FuseAlertComponent } from "./alert.component";
import { ButtonWrapperComponent } from "../button-wrapper/button-wrapper.component";
import { MatDividerModule } from "@angular/material/divider";

@NgModule({
    declarations: [FuseAlertComponent],
    imports: [CommonModule, MatButtonModule, MatIconModule, ButtonWrapperComponent, MatDividerModule],
    exports: [FuseAlertComponent],
})
export class FuseAlertModule {}
